import { render, staticRenderFns } from "./Excedentes.vue?vue&type=template&id=84e296f0&"
import script from "./Excedentes.vue?vue&type=script&lang=js&"
export * from "./Excedentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports